export default "__VITE_ASSET__BFXnZ_Sd__"